// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__aUi_l","productName":"Table_productName__2vd6o"};